import React from 'react'

import { useTranslation } from '@/core/i18n/useTranslation'
import Icon from '@/shared/components/atoms/Icon'

export const PaymentMethodError: React.FC = () => {
	const { t } = useTranslation('common')

	return (
		<div className="bg-card border border-border rounded-xl p-6 mb-4">
			<div className="flex items-center gap-3">
				<Icon name="x-circle-fill" className="h-6 w-6 text-red-500" />
				<div>
					<h3 className="text-lg font-semibold text-red-500">
						{t('subscribe.payment_method_failed')}
					</h3>
					<p className="text-sm text-muted-foreground">
						{t('subscribe.payment_method_failed_desc')}
					</p>
				</div>
			</div>
		</div>
	)
}
